
interface AvatarDisplayProps {
  profilePhoto?: string | null;
  companyLogo?: string | null;
  firstName?: string;
  lastName?: string;
  size?: number;
  className?: string;
  isLoading?: boolean;
}

// ............................... getInitials ................................

const getInitials = (firstName?: string, lastName?: string) => {
  const first = firstName?.trim()?.charAt(0)?.toUpperCase() || "";
  const last = lastName?.trim()?.charAt(0)?.toUpperCase() || "";
  return `${first}${last}` || "N/A";
};

const AvatarDisplay = ({
  profilePhoto,
  companyLogo,
  firstName,
  lastName,
  size = 84,
  className = "",
  isLoading = false,
}: AvatarDisplayProps) => {
  const dimension = { width: size, height: size };

  if (isLoading) {
    return (
      <div
        className={`gx-avatar-initials gx-avatar-skeleton ${className}`}
        style={dimension}
        aria-label="Loading profile"
      />
    );
  }

  if (profilePhoto) {
    return (
      <img
        src={profilePhoto}
        alt="Profile"
        className={`gx-avatar-photo ${className}`}
        style={dimension}
      />
    );
  }

  if (companyLogo) {
    return (
      <img
        src={companyLogo}
        alt="Company logo"
        className={`gx-avatar-photo gx-avatar-logo ${className}`}
        style={dimension}
      />
    );
  }

  return (
    <div
      className={`gx-avatar-initials ${className}`}
      style={dimension}
      aria-label="Profile initials"
    >
      {getInitials(firstName, lastName)}
    </div>
  );
};

export default AvatarDisplay;
